module.exports = __webpack_public_path__ + "img/portfolio8.a543f7b4.jpg";